<template>
    <section class="calendar">
        <transition name="fade" mode="out-in">
            <div class="preloader" v-if="loading">
                <div class="circle-border-1">
                    <div class="circle-core-1"></div>
                </div> 
                <div class="circle-border-2">
                    <div class="circle-core-2"></div>
                </div> 
            </div>
            <VueSlickCarousel v-bind="settings" v-if="months.length && !loading">
                <div class="calendar-list" v-for="(month, index) in months" :key="index">
                    <div class="calendar-month">
                        {{ month.name }}
                    </div>
                    <div class="calendar-item name-day" v-for="name in weeks" :key="name">{{ name }}</div>
                    
                    <div class="calendar-item num-day" v-for="(day, key) in month.days" :key="key" 
                        :style="{ gridColumn: column(key, index), background: checkColor(day) }"
                    >
                        <a :href="`/?${type ? `type=${type}&` : ''}${year ? `year=${year}&` : ''}date=${day.format('YYYY-MM-DD')}`"
                            v-if="checkColor(day)">{{ day.format('D') }}
                        </a>
                        <div v-else>{{ day.format('D') }}</div>
                    </div>
                </div>
            </VueSlickCarousel>
        </transition>
    </section>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
    data() {
        return {
            type: new URL(location.href).searchParams.get('type'),
            year: new URL(location.href).searchParams.get('year'),
            loading: true,
            events: [],
            weeks: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
            months: [],
            settings: {
                centerMode: true,
                autoplay: false,
                centerPadding: '10px',
                focusOnSelect: true,
                infinite: true,
                slidesToShow: 3,
                initialSlide: moment().startOf('month').format('M') - 1,
                responsive: [
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            }
        }
    },
    mounted: async function() {
        await this.loadEvents();

        for(let i = 0; i < 12; i++) {
            if(this.year) {
                var month = moment(this.year).month(i).startOf('month');
                this.settings.initialSlide = 0;
            } else {
                var month = moment().month(i).startOf('month');
            }

            this.months.push({
                'name': moment().month(i).locale('ru').format('MMMM'),
                'days':
                    [...Array(month.daysInMonth())].map((_, i) => {
                        return month.clone().add(i, 'day')
                    })
            });
        }
    },
    methods: {
        column(key, index) {
            if (key == 0) {
                return this.months[index].days[0].isoWeekday()
            }
        },

        checkColor(day) {
            let colour = '';

            this.events.find(function (item) {
                if(moment(day).isSame(item.start_at, 'day', 'month', 'year')) {
                    colour = item.color;
                }
            })

            return colour;
        },

        async loadEvents() {
            await axios.get('api/events', { params: { type: this.type, year: this.year }})
            .then(res => {
                this.events = res.data;

                setTimeout(() => {
                    this.loading = false;
                }, 250);
            })
        }
    },
    components: {
        axios,
        moment,
        VueSlickCarousel
    }
}
</script>

<style>
.fade-enter-active, .fade-leave-active
{
    transition: opacity 0.5s
}

.fade-enter, .fade-leave-to {
    opacity: 0
}

.calendar-list {
    display: grid !important;
    grid-template-columns: repeat(7, 1fr);
    max-width: 350px;
    width: 100%;
    margin: 0 auto;
}

.calendar-month {
    font-family: FedraSansPro-Normal;
    text-transform: uppercase;
    font-size: 30px;
    grid-column: 1 / 8;
    text-align: center;
    margin-bottom: 10px;
}

.name-day {
    font-family: FedraSansPro-Book;
    font-size: 24px;
}

.num-day {
    font-family: FedraSansPro-Light;
    font-size: 24px;
}

.calendar-item {
    align-items: center;
    display: flex;
    justify-content: center;
    position: relative;
    border-radius: 10px;
}

.calendar-item:hover {
    transform: scale(1.05);
}

.calendar-item a {
    width: 100%;
    height: 100%;
    align-items: center;
    display: flex;
    justify-content: center;
}

.calendar-item::before {
    content: "";
    display: inline-block;
    height: 0;
    padding-bottom: 100%;
    width: 1px;
}

.slick-slide {
    opacity: 0.5;
    padding: 10px;
}

.slick-center {
    opacity: 1;
}

.slick-prev {
    left: -30px;
}

.slick-next {
    right: -30px;
}

@media screen and ( max-width: 768px ) {
    .slick-prev {
        left: -20px;
    }
    .slick-next {
        right: -20px;
    }
}

.slick-prev, .slick-next {
    font-size: 0;
    line-height: 0;
    position: absolute;
    top: 50%;
    display: block;
    width: 30px;
    height: 60px;
    padding: 0;
    transform: translate(0, -50%);
    cursor: pointer;
    color: transparent;
    border: none;
    outline: none;
    background-repeat: no-repeat;
    background-position: center;
}

.preloader {
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
}

.circle-border-1 {
    position: absolute;
    width: 150px;
    height: 150px;
    padding: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background: #154194;
    background: linear-gradient(0deg, rgba(63,249,220,0.1) 20%, #154194 100%);
    animation: spin3D 1.8s linear 0s infinite;
}

.circle-core-1 {
    width: 100%;
    height: 100%;
    background-color: #37474faa;
    border-radius: 50%;
}

.circle-border-2 {
    position: absolute;
    width: 150px;
    height: 150px;
    padding: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background: #C8CCCC;
    background: linear-gradient(0deg, rgba(251, 91, 83, 0.1) 20%, #C8CCCC 100%);
    animation: spin3D 2.2s linear 0s infinite;
}

.circle-core-2 {
    width: 100%;
    height: 100%;
    background-color: #1d2630aa;
    border-radius: 50%;
}

@keyframes spin3D {
    from {
      transform: rotate3d(.5,.5,.5, 360deg);
    }
    to {
      transform: rotate3d(0,0,0, 0deg);
    }
}

</style>